import React from 'react';
import { Text } from '@chakra-ui/react';

type Props = {
  text: string;
  fontsize?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
};

export const LineBreakText = (props: Props) => {
  const { text, fontsize = 'sm' } = props;

  return (
    <>
      {text.split('\\n').map((line, index) => (
        <Text fontSize={fontsize} key={index}>
          {line}
          <br />
        </Text>
      ))}
    </>
  );
};
